import { connect, useDispatch } from 'react-redux';
import { bannerAction } from '../_actions';
import React, { useState, useEffect } from 'react';
import NavBar from '../_components/navbar';
import { withRouter } from '../_helpers/withRouter';
import { Button, Container, Row, Col, Card, CardBody, UncontrolledTooltip, Input, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faPlusCircle, faSearch, faTimes, faChevronLeft, faChevronRight, faAd, faImage } from '@fortawesome/free-solid-svg-icons'
import { authActions } from '../_actions';
import { useNavigate } from 'react-router-dom';

const Banner = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [term, setTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit] = useState(12);

    // Delete validation state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const bannerArray = props.banner?.banner || [];

    useEffect(() => {
        dispatch(bannerAction.getBanner());
    }, []);

    const handleChange = event => {
        setTerm(event.target.value);
        setPage(1);
    };

    const confirmDelete = (id) => {
        setItemToDelete(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = () => {
        if (itemToDelete) {
            dispatch(bannerAction.deleteBannerById(itemToDelete));
            setDeleteModalOpen(false);
            setItemToDelete(null);
        }
    };

    // Client-side Filtering
    const filteredBanners = bannerArray ? bannerArray.filter((item) => {
        if (!term) return true;
        const lowerTerm = term.toLowerCase();
        return (item.nome || '').toLowerCase().includes(lowerTerm) ||
            (item.descricao || '').toLowerCase().includes(lowerTerm);
    }) : [];

    // Client-side Pagination
    const totalItems = filteredBanners.length;
    const totalPages = Math.ceil(totalItems / limit);
    const paginatedBanners = filteredBanners.slice((page - 1) * limit, page * limit);

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Banners</h2>
                        <p className="text-muted mb-0">Gerencie os banners de destaque do sistema</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ maxWidth: '300px' }}>
                            <Input
                                id="term"
                                placeholder="Buscar por nome ou descrição..."
                                value={term}
                                onChange={handleChange}
                                style={{
                                    paddingLeft: '40px',
                                    borderRadius: '50px',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                    height: '45px'
                                }}
                            />
                            <FontAwesomeIcon
                                icon={faSearch}
                                className="text-muted position-absolute"
                                style={{ left: '15px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                            {term && (
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="text-muted position-absolute cursor-pointer"
                                    onClick={() => { setTerm(''); setPage(1); }}
                                    style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                />
                            )}
                        </div>

                        <Button
                            id="btnNovo"
                            color="primary"
                            className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                            style={{ borderRadius: '50px', fontWeight: '600', height: '45px', backgroundColor: 'var(--primary-color)' }}
                            onClick={() => navigate("/banner")}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                            <span className="text-nowrap">Novo Banner</span>
                        </Button>
                        <UncontrolledTooltip placement="bottom" target="btnNovo">
                            Adicionar um novo banner
                        </UncontrolledTooltip>
                    </div>
                </div>

                {/* Grid Section */}
                {paginatedBanners.length > 0 ? (
                    <>
                        <Row>
                            {paginatedBanners.map((item) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={item.id}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column">

                                            <div className="d-flex align-items-center mb-4">
                                                <div className="d-flex justify-content-center align-items-center bg-light text-success rounded-circle mr-3"
                                                    style={{ width: '50px', height: '50px', backgroundColor: 'var(--primary-light)' }}>
                                                    <FontAwesomeIcon icon={faAd} size="lg" />
                                                </div>
                                                <div style={{ overflow: 'hidden' }}>
                                                    <h5 className="mb-1 font-weight-bold text-dark text-truncate" title={item.nome}>
                                                        {item.nome}
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-start text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2 mt-1">
                                                        <FontAwesomeIcon icon={faImage} className="text-muted" />
                                                    </div>
                                                    <p className="text-muted mb-0 small" style={{ display: '-webkit-box', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                        {item.descricao || 'Sem descrição cadastrada.'}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="mt-auto pt-3 border-top d-flex justify-content-end align-items-center">
                                                <div className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: 'var(--primary-color)' }}
                                                        component='a'
                                                        href={`/banner/${item.id}`}
                                                        title="Editar"
                                                    >
                                                        <FontAwesomeIcon icon={faPen} size="sm" />
                                                    </Button>
                                                    {authActions.isGestor() && (
                                                        <Button
                                                            color="danger"
                                                            className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                                            style={{ width: '38px', height: '38px', padding: 0, backgroundColor: '#e03131' }}
                                                            onClick={() => confirmDelete(item.id)}
                                                            title="Excluir"
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} size="sm" />
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faAd} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhum banner encontrado</h4>
                            <p className="text-muted">Não encontramos banners com os filtros atuais.</p>
                            {term && (
                                <Button color="primary" outline onClick={() => { setTerm(''); setPage(1); }} className="mt-2 rounded-pill px-4">
                                    Limpar Filtros
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                <ModalHeader toggle={() => setDeleteModalOpen(false)} className="border-0 pb-0"></ModalHeader>
                <ModalBody className="text-center pb-4">
                    <div className="mb-3 text-danger bg-light-danger d-inline-block rounded-circle p-3" style={{ backgroundColor: '#ffebee' }}>
                        <FontAwesomeIcon icon={faTrash} size="2x" />
                    </div>
                    <h4 className="mb-2 font-weight-bold">Excluir Banner</h4>
                    <p className="text-muted mb-4">Tem certeza que deseja excluir este banner? Esta ação não pode ser desfeita.</p>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <Button color="light" onClick={() => setDeleteModalOpen(false)} className="mr-2 rounded-pill px-4 font-weight-bold">Cancelar</Button>
                    <Button color="danger" onClick={handleDelete} className="rounded-pill px-4 font-weight-bold shadow-sm">Confirmar Exclusão</Button>
                </ModalFooter>
            </Modal>

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = (state) => ({
    banner: state.banner
});

const connectedBannerPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Banner));

export { connectedBannerPage as Banner };
